define('common/ko/customBinding/markdown',['knockout', 'common/markdown'], function (ko, markdown) {

    ko.bindingHandlers.markdown = {
        init: function(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            element.classList.add('markdown');
            ko.applyBindingsToNode(element, {
                'html': ko.pureComputed(function() {
                    var value = valueAccessor();
                    return value ? markdown.convert(value) : '';
                })
            }, bindingContext);
        }
    };
});

